import { bl_sfa_deal_event_RowClass } from "../../../dbschema/bl_sfa_deal_event.model";
import { bl_sfa_deal_ext_RowClass } from "../../../dbschema/bl_sfa_deal_ext.model";
import { bl_sfa_deal_hdr_RowClass } from "../../../dbschema/bl_sfa_deal_hdr.model";
import { bl_sfa_deal_line_RowClass } from "../../../dbschema/bl_sfa_deal_line.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaDealContainerModel extends BaseContainerModel {
    bl_sfa_deal_hdr: bl_sfa_deal_hdr_RowClass = new bl_sfa_deal_hdr_RowClass();
    bl_sfa_deal_events : bl_sfa_deal_event_RowClass[] =[];
    bl_sfa_deal_exts : bl_sfa_deal_ext_RowClass[]=[];
    bl_sfa_deal_lines : bl_sfa_deal_line_RowClass[]=[];
}